import React, { useContext, useCallback, useEffect } from "react";
import styles from "./styles.module.scss";
import cn from "classnames";
import Accordion from "react-bootstrap/Accordion";
import AccordionContext from "react-bootstrap/AccordionContext";

import { format, isPast } from "date-fns";
import { convertToGmt0 } from "helpers/prepareSchedule";

export default function ScheduleAccordion({
  schedule,
  currentShow,
  tabActiveShow,
  actions,
  togglerClassName,
  contentClassName,
  formattedTimeZone,
}) {
  const isPastShow = useCallback((date) => {
    return isPast(convertToGmt0(date));
  }, []);

  return (
    <>
      <ContextAwareToggle
        eventKey={schedule.date}
        togglerClassName={togglerClassName}
        actions={actions}
      >
        <div className="d-flex justify-content-between">
          <span>{format(new Date(schedule.date), "eeee")}</span>
          <span>{format(new Date(schedule.date), "LLLL d")}</span>
        </div>
      </ContextAwareToggle>
      <Accordion.Collapse eventKey={schedule.date}>
        <div className={cn(styles.content, contentClassName, "p-3")}>
          {Array.isArray(schedule?.shows) &&
            schedule.shows.map((item, index) => (
              <div
                className={cn(
                  styles.card,
                  isPastShow(item.startAt) && styles.past,
                  currentShow?.id === item.id && styles.current,
                  tabActiveShow === item.id && styles.active,
                  "position-relative"
                )}
                key={index}
                onClick={() => actions.setTabActiveShow(item.id)}
              >
                <span className={styles.dot} />
                <div className="d-flex">
                  <div className={styles.line}></div>
                  <div className={cn(styles.text, "ms-3 p-2 w-100")}>
                    <span className={"d-inline-block w-100 fw-bold"}>
                      {format(new Date(item.startAtFormated), "p")}{" "}
                      {formattedTimeZone}
                    </span>
                    {item.title}
                  </div>
                </div>
              </div>
            ))}
        </div>
      </Accordion.Collapse>
    </>
  );
}

function ContextAwareToggle({ children, eventKey, togglerClassName, actions }) {
  const currentEventKey = useContext(AccordionContext);

  const isCurrentEventKey = currentEventKey?.activeEventKey === eventKey;

  const id = eventKey.toString().split(" ").join("");

  let timerId = null;

  useEffect(() => {
    return () => clearTimeout(timerId);
  });

  const onClick = (e) => {
    actions.switchDayTab(eventKey);

    const currentElement = document.getElementById(id);

    if (window.innerWidth < 992) {
      const top = currentElement.offsetTop;

      timerId = setTimeout(() => {
        if (top !== currentElement.offsetTop) {
          currentElement.scrollIntoView({ block: "center" });
        }
      }, 300);
      return;
    }

    const isView = elementInViewport(currentElement);

    timerId = setTimeout(() => {
      if (!isView) {
        currentElement.scrollIntoView();
      }
    }, 300);

    e.preventDefault();
  };

  return (
    <div
      id={id}
      className={cn(
        styles.toggler,
        isCurrentEventKey && styles.active,
        togglerClassName
      )}
      onClick={onClick}
    >
      {children}
    </div>
  );
}

function elementInViewport(el) {
  let top = el.offsetTop;
  let left = el.offsetLeft;
  let width = el.offsetWidth;
  let height = el.offsetHeight;

  while (el.offsetParent) {
    el = el.offsetParent;
    top += el.offsetTop;
    left += el.offsetLeft;
  }

  return (
    top < window.pageYOffset + window.innerHeight &&
    left < window.pageXOffset + window.innerWidth &&
    top + height > window.pageYOffset &&
    left + width > window.pageXOffset
  );
}
